import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async syncTickets({ commit }) {
      try {
        return await api.get('/chrons/tickets')
      } catch (error) {
        throw error
      }
    },

    async syncAllTicketsLogs({ commit }) {
      try {
        return await api.get('/chrons/logs')
      } catch (error) {
        throw error
      }
    },

    async getTickets({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/registers/tickets?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async linkClient({ commit }, data) {
      try {
        return await api.post('/registers/tickets/link-client', data)
      } catch (error) {
        throw error
      }
    },

    async unlinkClient({ commit }, data) {
      try {
        return await api.post('/registers/tickets/unlink-client', data)
      } catch (error) {
        throw error
      }
    },

    async getTicket({ commit }, ticketId) {
      try {
        const response = await api.get(`/registers/tickets/${ticketId}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async syncTicketLogs({ commit }, ticketId) {
      try {
        return await api.post(`/registers/tickets/${ticketId}/logs`)
      } catch (error) {
        throw error
      }
    },

    async getTicketLogs({ commit }, id) {
      try {
        const response = await api.get(`/registers/tickets/${id}/logs`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
